import * as React from 'react';
import * as queryString from 'query-string';
import CustomersTable from './CustomersTable';
import { RouteComponentProps } from 'react-router';

interface ICustomersProps extends RouteComponentProps<{ eshop: string, customerId?: string, }> { }

class Customers extends React.Component<ICustomersProps> {

  state = {
    loading: false,
    status: 'pending',
    searchQuery: ''
  };

  render() {
    return (
      <div>
        <CustomersTable
          goToUrl={url => this.props.history.push(url)}
          domain={this.props.match.params.eshop}
          customerId={this.props.match.params.customerId}
          searchQuery={this.state.searchQuery}
          filter={queryString.parse(this.props.location.search)}
          onSearch={filter => this.changeSearchQuery(filter)}
        />
      </div>
    );
  }

  private changeSearchQuery(searchQuery: any) {
    const qs = queryString.stringify(searchQuery);
    this.props.history.push(`?${qs}`);
    this.setState({ searchQuery });
  }
}

export default Customers;



// WEBPACK FOOTER //
// ./src/scenes/Customers/index.tsx